/**
 * @file 全景-央视红色足迹地图路由模块
 * @author liuyanan06
 */
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Main',
            component: () => import(/* webpackChunkName: "Main" */ './views/Main/Main'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/pano',
            name: 'Pano',
            component: () => import(/* webpackChunkName: "Pano" */ './views/Pano/Pano'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/welfare',
            name: 'Welfare',
            component: () => import(/* webpackChunkName: "Welfare" */ './views/Welfare/Welfare'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/note',
            name: 'Note',
            component: () => import(/* webpackChunkName: "Note" */ './views/Note/Note'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/share',
            name: 'Share',
            component: () => import(/* webpackChunkName: "Share" */ './views/Share/Share'),
            meta: {
                keepAlive: false
            }
        },
        // 大逃杀首页
        {
            path: '/escape',
            name: 'Escape',
            component: () => import(/* webpackChunkName: "Escape" */ './views/Escape/Escape'),
            meta: {
                keepAlive: false
            }
        },
        // 闯关首页
        {
            path: '/kingRoad',
            name: 'KingRoad',
            component: () => import(/* webpackChunkName: "kingRoad" */ './views/KingRoad/KingRoad'),
            meta: {
                keepAlive: false
            }
        }
    ]
});
